module.exports = __webpack_public_path__ + "static/Otyugh-9dbbb7e655422c25a16664d9c618b65c.jpg";